export default function isObjectNullOrEmpty(obj, keysToDisplay) {
  if (!obj) {
    return true;
  }
  for (let i = 0; i < keysToDisplay.length; i += 1) {
    if (obj[keysToDisplay[i]] !== null && obj[keysToDisplay[i]] !== undefined && obj[keysToDisplay[i]] !== ''
      && obj[keysToDisplay[i]] !== '0' && obj[keysToDisplay[i]] !== '0.00' && obj[keysToDisplay[i]] !== -1
      && !Array.isArray(obj[keysToDisplay[i]])) {
      return false;
    }
    if (Array.isArray(obj[keysToDisplay[i]])) {
      if (obj[keysToDisplay[i]].length) {
        return false;
      }
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/isObjectNullOrEmpty.js